import script from "./GroupPurchaseList.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupPurchaseList.vue?vue&type=script&setup=true&lang=js"

import "./GroupPurchaseList.vue?vue&type=style&index=0&id=de8dfec6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de8dfec6"]])

export default __exports__